import {action} from 'utils/redux';
import namespace from './namespace';
import {P, Nullable} from 'utils/types';
import createReminderActions from 'fragments/callReminder/actions';

const creator = action(namespace);

export const initialize = creator('initialize');

export const destroy = creator('destroy');

export const updateCalendarQuery = creator('updateCalendarQuery', P.Object);

export const updateCalendarResources = creator('updateCalendarResources');

export const createCalendarResources = creator('createCalendarResources', P.Object);

export const removeCalendarResources = creator('removeCalendarResources', P.Array);

export const updateCalendarResource = creator('updateCalendarResource', P.Object);

export const toggleItemsViewer = creator('toggleItemsViewer', P.Bool);

export const toggleItemsCreator = creator('toggleItemsCreator', P.Bool);

export const setSlotSelection = creator('setSlotSelection', P.Object);

export const clearSlotSelection = creator('clearSlotSelection');

export const searchBuildings = creator('searchBuildings', P.Object);

export const searchUsers = creator('searchUsers', P.Object);

export const createEncounter = creator('createEncounter', P.Object);

export const refreshSelectedBuildingClients = creator(
	'refreshSelectedBuildingClients',
	P.Number,
);

export const setSelectedItem = creator('setSelectedItem', Nullable(P.Object));

// private version of the same
export const _setSelectedItem = creator('_setSelectedItem', Nullable(P.Object));

export const openEncounterPreview = creator('openEncounterPreview', P.Object);

export const closeEncounterPreview = creator('closeEncounterPreview');

export const setItemReservationCancellation = creator(
	'setItemReservationCancellation',
	P.Boolean,
);

export const saveCalendarResourceEditForm = creator(
	'saveCalendarResourceEditForm',
	P.Object,
);

export const setAreasEditorOpen = creator('setAreasEditorOpen', P.Boolean);

export const setDateEditorOpen = creator('setDateEditorOpen', P.Boolean);

export const fetchBuildingCalendarResources = creator(
	'fetchBuildingCalendarResources',
	P.Number,
);

export const clearBuildingCalendarResources = creator('clearBuildingCalendarResources');

export const openCalendarBuildingModal = creator('openCalendarBuildingModal', P.Object);

export const closeCalendarBuildingModal = creator('closeCalendarBuildingModal');

export const openBonusItemReservationModal = creator(
	'openBonusItemReservationModal',
	P.Object,
);

export const closeBonusItemReservationModal = creator('closeBonusItemReservationModal');

export const reserveBonusItem = creator('reserveBonusItem', P.Object);

export const openAddBuildingModal = creator('openAddBuildingModal', P.String);

export const closeAddBuildingModal = creator('closeAddBuildingModal');

export const openMapModal = creator('openMapModal', P.Object);

export const closeMapModal = creator('closeMapModal');

export const addBuilding = creator('addBuilding');

export const openRoutePlanner = creator('openRoutePlanner');

export const openVisitAiModal = creator('openVisitAiModal');

export const closeVisitAiModal = creator('closeVisitAiModal');

export const fetchVisitAiResult = creator('fetchVisitAiResult', P.String);

export const analyzeVisitAi = creator('analyzeVisitAi', P.Object);

export const subscribeVisitAiChannel = creator('subscribeVisitAiChannel');

export const unsubscribeVisitAiChannel = creator('unsubscribeVisitAiChannel');

export const reinitialize = creator('reinitialize');

export const toggleLockModal = creator('toggleLockModal');

export const _setMarketingLeadSources = creator('_setMarketingLeadSources');

export const _setVisitAiResult = creator('_setVisitAiResult');

export const _setVisitAiLoading = creator('_setVisitAiLoading', P.Bool);

export const _setVisitAiAnalyzing = creator('_setVisitAiAnalyzing', P.Bool);

export const _updateCalendarQuery = creator('_updateCalendarQuery', P.Object);

export const _setCalendarResources = creator('_setCalendarResources', P.Array);

export const _addCalendarResources = creator('_addCalendarResources', P.Array);

export const _removeCalendarResources = creator('_removeCalendarResources', P.Array);

export const _updateCalendarResource = creator('_updateCalendarResource', P.Object);

export const _setActiveOrganizationTeams = creator(
	'_setActiveOrganizationTeams',
	P.Array,
);

export const _setAllTeams = creator('_setAllTeams', P.Array);

export const _setPreviewableEncounter = creator('_setPreviewableEncounter', P.Object);

export const _resetEditors = creator('_resetEditors');

export const _setBuildingCalendarResources = creator(
	'_setBuildingCalendarResources',
	P.Array,
);

export const _setBonusItemBeingReserved = creator('_setBonusItemBeingReserved', P.Object);

export const _setBuildingToAddCoords = creator('_setBuildingToAddCoords', P.Array);

export const _addBuilding = creator('_addBuilding');

export const _initialize = creator('_initialize');

export const _startOp = creator('_startOp');

export const _opOk = creator('_opOk');

export const _opFailed = creator('_opFailed');

export const _setBuilding = creator('_setBuilding');

export const _setLead = creator('_setLead', P.Object);

export const _setUserTeam = creator('_setUserTeam', P.Object);

export const _setProducts = creator('_setProducts');

export const _openToDate = creator('_openToDate', P.Date);

const reminderActions = createReminderActions({namespace});

export const {
	createCallReminder,
	createCalendarCallReminder,
	updateCallReminder,
	removeCallReminder,
	toggleCallReminderEditor,
	setReminderSeen,
	_setCalendarCallReminderSeen,
	_setCallReminder,
	_setCallReminderLoading,
	_setCallReminders,
	_setCallRemindersLoading,
	_setCalendarCallReminder,
} = reminderActions;

export const onReminderClick = creator('onReminderClick');

export const setCallReminderBuilding = creator('setCallReminderBuilding');

export const toggleClientEditor = creator('toggleClientEditor');

export const saveClient = creator('saveClient', P.Object);

export const _clientSaved = creator('_clientSaved');

export const _setLockData = creator('_setLockData');

export const saveCalendarEventEditForm = creator('saveCalendarEventEditForm', P.Object);

export const _updateCalendarEvent = creator('_updateCalendarEvent', P.Object);

export const createCalendarEvent = creator('createCalendarEvent', P.Object);

export const _createCalendarEvent = creator('_createCalendarEvent', P.Object);

export const deleteCalendarEvent = creator('deleteCalendarEvent', P.Object);

export const restoreCalendarEvent = creator('restoreCalendarEvent', P.Object);

export const searchCalendarEventTypes = creator('searchCalendarEventTypes', P.Object);

export const _setCalendarEventTypes = creator('_setCalendarEventTypes', P.Array);

export const _replaceItemById = creator('_replaceItemById', P.Object);
